
<template>
    <div class="tcjs-item-list" :class="{'tc-drawing-menu-dark': menuDark}" :style="list_style()"
        @mousedown="thismousedown">
        <template v-for="(item, index) in items">
            <!-- Category Header -->
            <div v-if="shouldShowCategory(item, index)" :key="'cat-' + index" class="tcjs-item-category">
                {{ item.category }}
            </div>

            <div v-if="!item.hidden" :class="item_class(item)"
                @click="e => item_click(e, item)"
                :key="index"
                :style="item_style(item)" role="button" tabindex="0"
                :aria-label="item.name" :title="item.name"
                @keydown.enter.stop.prevent="e => item_click(e, item)"
                @keydown.space.stop.prevent="e => item_click(e, item)"
                @keydown.esc.stop="$emit('close-list')">
                <div class="tc-tbicon"
                    :style="icon_style(item)">
                </div>
                <div class="tcjs-item-list-label">{{item.name}}</div><button class="tc-drawing-favorite" @click.stop="favorite(item)" :aria-label="'Favorite '+item.name" :aria-pressed="favorites.includes(item.type)"><svg width="16" height="16" viewBox="0 0 24 24" :fill="favorites.includes(item.type) ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9z"/></svg></button>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name: 'ItemList',
    props: ['anchor', 'config', 'items', 'colors', 'dc'],
    mounted() {
        this.updatePosition()
        window.addEventListener(
            'mousedown', this.onmousedown
        )
        window.addEventListener('resize', this.updatePosition)
        window.addEventListener('scroll', this.updatePosition, true)
    },
    beforeDestroy() {
        window.removeEventListener(
            'mousedown', this.onmousedown
        )
        window.removeEventListener('resize', this.updatePosition)
        window.removeEventListener('scroll', this.updatePosition, true)
    },
    computed: {
        menuDark() {
            const color=String(this.colors?.back || '#ffffff');
            const hex=color.match(/^#([a-f0-9]{3}|[a-f0-9]{6})$/i);
            const rgb=hex ? (hex[1].length===3 ? hex[1].split('').map(c=>parseInt(c+c,16)) : [0,2,4].map(i=>parseInt(hex[1].slice(i,i+2),16))) : color.match(/[\d.]+/g)?.slice(0,3).map(Number);
            return rgb?.length===3 ? rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722<128 : false;
        }
    },
    methods: {
        favorite(item) {
            this.favorites = this.favorites.includes(item.type) ? this.favorites.filter(x=>x!==item.type) : [...this.favorites,item.type];
            localStorage.setItem('tc_drawing_favorites',JSON.stringify(this.favorites));
            window.dispatchEvent(new Event('tc-drawing-favorites'));
        },
        shouldShowCategory(item, index) {
            if (!item.category) return false
            if (index === 0) return true
            // Find previous visible item
            for (let i = index - 1; i >= 0; i--) {
                if (!this.items[i].hidden) {
                    return item.category !== this.items[i].category
                }
            }
            return true
        },
        updatePosition() {
            this.$nextTick(() => {
                const parent = this.anchor || (this.$el && this.$el.parentElement)
                if (!parent) return
                const rect = parent.getBoundingClientRect()
                const width=Math.min(320,window.innerWidth-rect.right-12);
                const height=Math.min(this.$el.offsetHeight,window.innerHeight-24);
                this.position = {
                    left: Math.max(8,Math.min(Math.round(rect.right+8),window.innerWidth-Math.max(220,width)-8)),
                    top: Math.max(12,Math.min(Math.round(rect.top-8),window.innerHeight-height-12))
                }
            })
        },
        list_style() {
            let conf = this.$props.config
            let w = conf.TOOLBAR
            let brd = this.colors.tbListBorder || this.colors.grid
            let bstl = `1px solid ${brd}`
            return {
                left: `${this.position.left || w}px`,
                top: `${this.position.top || 0}px`,
                background: this.colors.back,
                borderTop: bstl,
                borderRight: bstl,
                borderBottom: bstl,
            }
        },
        item_class(item) {
            if (this.dc.tool === item.type) {
                return "tcjs-item-list-item selected-item"
            }
            return "tcjs-item-list-item"
        },
        item_style(item) {
            let conf = this.$props.config
            let h = conf.TB_ICON + conf.TB_ITEM_M * 2 // Reduced height
            return {
                height: `${h}px`
            }
        },
        icon_style(data) {
            let conf = this.$props.config
            let im = conf.TB_ITEM_M
            let sz = 24

            return {
                'background-image': `url(${data.icon})`,
                'width': `${sz}px`,
                'height': `${sz}px`,
                'margin': `${im}px`
            }
        },
        item_click(e, item) {
            e.cancelBubble = true
            this.$emit('item-selected', item)
            this.$emit('close-list')
        },
        onmousedown() {
            this.$emit('close-list')
        },
        thismousedown(e) {
            e.stopPropagation()
        }
    },
    data() {
        return {
            favorites: JSON.parse(localStorage.getItem('tc_drawing_favorites') || '[]'),
            position: { left: 0, top: 0 }
        }
    }
}

</script>

<style>
.tcjs-item-list { --drawing-bg:#fff; --drawing-text:#20242c; --drawing-muted:#737780; --drawing-border:#e6e7ea; --drawing-hover:#f1f2f4; font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif; position:fixed; box-sizing:border-box; width:320px; max-width:calc(100vw - 68px); max-height:calc(100dvh - 24px); overflow-y:auto; overscroll-behavior:contain; scrollbar-width:thin; padding:8px; margin:0; z-index:2147483000; border:1px solid var(--drawing-border)!important; border-radius:12px; background:var(--drawing-bg)!important; color:var(--drawing-text); box-shadow:0 8px 32px #17213b20; user-select:none; }
.tcjs-item-list.tc-drawing-menu-dark { --drawing-bg:#20242d; --drawing-text:#e7e9ee; --drawing-muted:#989eac; --drawing-border:#363c48; --drawing-hover:#303642; box-shadow:0 8px 32px #0005; color-scheme:dark; }
.tcjs-item-category { padding:16px 12px 8px; margin-top:8px; border-top:1px solid var(--drawing-border); font-size:11px; line-height:1.5; font-weight:500; letter-spacing:.09em; text-transform:uppercase; color:var(--drawing-muted); }
.tcjs-item-category:first-child { margin-top:0; border-top:0; padding-top:10px; }
.tcjs-item-list-item { display:flex; align-items:center; min-height:44px; height:auto!important; padding:3px 10px; gap:10px; border-radius:8px; color:var(--drawing-text); cursor:pointer; font-size:14px; }
.tcjs-item-list-item:hover,.tcjs-item-list-item.selected-item,.tcjs-item-list-item:focus-visible { background:var(--drawing-hover)!important; color:var(--drawing-text); outline:none; }
.tcjs-item-list-label { flex:1; min-width:0; line-height:1.4; }
.tcjs-item-list-item > .tc-tbicon { position:relative!important; flex:none; margin:0!important; background-size:contain; background-repeat:no-repeat; background-position:center; filter:brightness(0)!important; }
.tc-drawing-menu-dark .tcjs-item-list-item > .tc-tbicon { filter:brightness(0) invert(.9)!important; }
.tc-drawing-favorite { flex:none; margin-left:auto; width:30px; height:30px; padding:0; display:inline-flex; align-items:center; justify-content:center; border:0; border-radius:6px; background:transparent; color:var(--drawing-muted); cursor:pointer; }
.tc-drawing-favorite:hover { background:var(--drawing-border); }
.tc-drawing-favorite[aria-pressed=true] { color:#4983ff; }
@media(max-width:600px) { .tcjs-item-list { width:280px; padding:6px; } .tcjs-item-list-item { min-height:44px; font-size:13px; gap:8px; } }
</style>
